module.exports = __webpack_public_path__ + "img/consultant02.d2a4f71c.jpg";